'use client'
import { DELETE } from '@/api/delete-request';
import { GET } from '@/api/get-request';
import { JourneyInterface } from '@/types/journey';
import { useNotifications } from '@toolpad/core/useNotifications';
import React, { createContext, useContext, ReactNode } from 'react';
import { useAuth } from './with-auth';

type JourneysContextType = {
    journeys: { [status: string]: JourneyInterface[] },
    GetJourneys: (page: number) => void,
    HandleDelete: (id: number) => void,
    loading: boolean
};

const JourneysContext = createContext<JourneysContextType | undefined>(undefined);

export const JourneysProvider = ({ children }: { children: ReactNode }) => {

    const [journeys, setJourneys] = React.useState<{ [status: string]: JourneyInterface[] }>({});
    const [loading, setLoading] = React.useState<boolean>(false);
    const { user } = useAuth();
    const notifications = useNotifications();

    const GetJourneys = async () => {

        setLoading(true);
        const response = await GET({
            url: `v1/journeys`
        });
        if (response.success)
            setJourneys(response.data);

        setLoading(false);


    };

    React.useLayoutEffect(() => {
        if (user)
            GetJourneys();
    }, []);

    const HandleDelete = async (id: number) => {
        const response = await DELETE({ url: `v1/journeys/${id}` });
        if (response.success) {
            setJourneys((prevJourneys) => {
                const newJourneys = { ...prevJourneys };

                for (const status in newJourneys) {
                    if (Array.isArray(newJourneys[status])) {
                        newJourneys[status] = newJourneys[status].filter(journey => journey.id.toString() !== id.toString());
                    }
                }

                return newJourneys;
            });
        }
        if (response)
            notifications.show(response.message, {
                severity: response.success ? 'success' : 'error',
                autoHideDuration: 3000,
            });
    };

    return (
        <JourneysContext.Provider
            value={{
                journeys,
                GetJourneys,
                HandleDelete,
                loading
            }}
        >
            {children}
        </JourneysContext.Provider>
    );
};

export const useJourneys = (): JourneysContextType => {
    const context = useContext(JourneysContext);
    if (!context) {
        throw new Error('useJourneys must be used within a JourneysProvider');
    }
    return context;
};


